//MapLayers.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as FeatureLayerLabels from "../Util/FeatureLayerLabels";
import * as MainMap from "../MainMap";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as WidgetHeading from "./WidgetHeading";

import { Button, Icon, Paper, Typography, Zoom } from "@mui/material";

import ActionButton from "@arcgis/core/support/actions/ActionButton";
import Collection from "@arcgis/core/core/Collection";

import React from "react";

export const themeName: string = "LayerListTheme";

const toolName: string = "Map Layers";
let toolDiv: string;

let layerListWidget: __esri.LayerList;

let childLayers: string[];
let noChildLayers: string[];
let lastLayerClicked: __esri.ListItem = null;

//Destroy the widget.
export function destroy() {
   if (layerListWidget) {
      layerListWidget = null;
   }
}

//Process all map services.  Base maps are not supported.
function listItemCreatedFunction(event: __esri.LayerListTriggerActionEvent) {
   const item = event.item;

   //Turn on parent layer if user turned on a child.  Pure genius!
   if (item.parent) {
      if (!childLayers.Contains(item.title)) {
         childLayers.Add(item.title);

         item.watch("visible", function (checkedOn: boolean, junk1, junk2, target: __esri.ListItem) {
            if (!target.parent.layer.visible && checkedOn) {
               target.parent.layer.visible = true;
            }
         }); //end item.watch
      }
   }

   //Make sure the layer is ready.
   item.layer.when().then(() => {
      const layer = item.layer;
      const featureLayer = layer as __esri.FeatureLayer;
      const mapImageLayer = layer as __esri.MapImageLayer;
      const layerName: string = featureLayer.id;

      //Enable opacity, legend, and info buttons on layers with no children.
      let createItems = false;

      if (mapImageLayer.type === "map-image" || mapImageLayer.type === "tile") {
         if (!item.parent) {
            createItems = true;
         }

      } else if (item.children.length === 0 && featureLayer.geometryType) {
         createItems = true;
      }

      if (createItems) {

         item.watch("visible", function (checkedOn: boolean, junk1, junk2, target: __esri.ListItem) {
            setLabelsLayerVisibility(layerName, checkedOn); //Turn labels layer on/off.
         }); //end item.watch

         //noChildLayers.Add(layerName);

         const actionItems = getActionItems(layer);
         if (actionItems) {
            item.actionsSections = actionItems;
         }

         const panelItem = getPanelItem(layer);
         if (panelItem) {
            item.panel = panelItem as __esri.ListItemPanel;
         }
      }
   });

} //End listItemCreatedFunction.

//Turn labels layer on or off by layer name (not by labels layer name).
function setLabelsLayerVisibility(layerName: string, visible: boolean) {
   let found: boolean = false;

   for (const labelSetting of Settings.labelLayers) {
      if (labelSetting.layerName === layerName) {
         const labelsLayer = Util_App.getOperationalLayerById(labelSetting.labelsLayerName) as __esri.Layer;
         if (labelsLayer) {
            found = true;
            setTimeout(function () { labelsLayer.visible = visible; }, 200); //Timeout is required.
         }
      }
   }
   if (found) {
      setTimeout(function () { FeatureLayerLabels.startProcessLabels(true); }, 300);
   }
}

//Get panel items.  This is the correct way, but full of bugs.
//function getPanelItem(layer: __esri.Layer): __esri.ListItemPanel {
//   let panelItem: __esri.ListItemPanel = null;
//   const llSpec: Settings.iLayerList = Util_App.getLayerListSpec(layer.title);

//   if (llSpec) {
//      if (llSpec.showLegend) {
//         panelItem = new ListItemPanel();
//         panelItem.content = "legend";
//         panelItem.open = llSpec.openLegend;
//      }
//   }
//   return panelItem;
//}

//Get panel items.  This is the hacky way.
function getPanelItem(layer: __esri.Layer): object {
   let panelItem: object = null;
   const llSpec: Settings.iLayerList = Util_App.getLayerListSpec(layer.title);

   if (llSpec) {
      if (llSpec.showLegend) {
         panelItem = {
            content: "legend",
            open: llSpec.openLegend,
         };
      }
   }
   return panelItem;
}

//Get item actions.
function getActionItems(layer: __esri.Layer): __esri.Collection<__esri.Collection<(__esri.ActionButton | __esri.ActionToggle)>> {
   let actionButton: __esri.ActionButton;

   //---------------------------------------------------------------------
   let opacityAndInfo: __esri.Collection<__esri.Collection<(__esri.ActionButton | __esri.ActionToggle)>> = new Collection;

   actionButton = new ActionButton({ title: "Decrease opacity", className: "esri-icon-down", id: "decrease-opacity", });
   opacityAndInfo.add(new Collection([actionButton]));

   actionButton = new ActionButton({ title: "Increase opacity", className: "esri-icon-up", id: "increase-opacity", });
   opacityAndInfo.add(new Collection([actionButton]));

   actionButton = new ActionButton({ title: "Zoom to this layer", className: "esri-icon-zoom-out-fixed", id: "full-extent", });
   opacityAndInfo.add(new Collection([actionButton]));

   actionButton = new ActionButton({ title: "Layer information", className: "esri-icon-description", id: "information", });
   opacityAndInfo.add(new Collection([actionButton]));

   //---------------------------------------------------------------------
   let opacityOnly: __esri.Collection<__esri.Collection<(__esri.ActionButton | __esri.ActionToggle)>> = new Collection;

   actionButton = new ActionButton({ title: "Decrease opacity", className: "esri-icon-down", id: "decrease-opacity", });
   opacityOnly.add(new Collection([actionButton]));

   actionButton = new ActionButton({ title: "Increase opacity", className: "esri-icon-up", id: "increase-opacity", });
   opacityOnly.add(new Collection([actionButton]));

   actionButton = new ActionButton({ title: "Zoom to this layer", className: "esri-icon-zoom-out-fixed", id: "full-extent", });
   opacityOnly.add(new Collection([actionButton]));

   //---------------------------------------------------------------------
   let infoOnly: __esri.Collection<__esri.Collection<(__esri.ActionButton | __esri.ActionToggle)>> = new Collection;

   actionButton = new ActionButton({ title: "Zoom to this layer", className: "esri-icon-zoom-out-fixed", id: "full-extent", });
   infoOnly.add(new Collection([actionButton]));

   actionButton = new ActionButton({ title: "Layer information", className: "esri-icon-description", id: "information", });
   infoOnly.add(new Collection([actionButton]));
   //---------------------------------------------------------------------

   const llSpec: Settings.iLayerList = Util_App.getLayerListSpec(layer.title);

   if (llSpec) {
      //Show both opacity and info.
      if (llSpec.showOpacity && llSpec.showInfo) {
         if (layer.opacity) {
            return opacityAndInfo;

         } else {
            return infoOnly;
         }

         //Show opacity only.
      } else if (llSpec.showOpacity) {
         if (layer.opacity) {
            return opacityOnly;
         }

         //Show info only
      } else if (llSpec.showInfo) {
         return infoOnly;
      }

   } else { //Show opacity buttons if no layer list spec.
      if (layer.opacity) {
         return opacityOnly;
      }
   }

   return null;
}

//An action button on the layer list was clicked.
function layerListTriggerAction(event: __esri.LayerListTriggerActionEvent) {
   const id = event.action.id;
   let layer = event.item.layer;
   let opacity = layer.opacity;
   let featureLayer = layer as __esri.FeatureLayer;

   if (id === "decrease-opacity") {
      opacity -= 0.10;
      if (opacity <= 0) {
         opacity = 0.01;
      }
      layer.opacity = opacity;

   } else if (id === "increase-opacity") {
      opacity += 0.10;
      if (opacity > 1) {
         opacity = 1;
      }
      layer.opacity = opacity;

   } else if (id === "full-extent") {
      MainMap.activeView.goTo(featureLayer.fullExtent).catch((error: Error) => {
         if (error.name !== "AbortError") {
            Util.errMsg(error.message);
         }
      });

   } else if (id === "information") {
      let url: string = featureLayer.url; //Hacky because it may not be a feature layer.

      if (layer.type === "feature") {
         url += "/" + featureLayer.layerId;
      }
      window.open(url);
   }
} //end layerListTriggerAction.

//Create layer list item click event to expand groups.
function createClickEvents() {
   const classNames = document.getElementsByClassName("esri-layer-list__item-title");

   for (const elem of classNames) {
      elem.addEventListener('click', layerListClickedHandler, { capture: false, passive: true });
   }
}

//Layer list handler function.
function layerListClickedHandler() {
   setTimeout(function () { layerListClicked(); }, 100); //Hacky
}

//Layer list item click event.
function layerListClicked() {
   if (layerListWidget.selectedItems && layerListWidget.selectedItems.length === 1) {
      const selectedItem = layerListWidget.selectedItems.getItemAt(0);
      selectedItem.open = !selectedItem.open;
      lastLayerClicked = selectedItem;

   } else {
      if (lastLayerClicked) {
         lastLayerClicked.open = !lastLayerClicked.open;
      }
   }
}

interface iProps {
   fadeIn: boolean;
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of MapLayers Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did update.
   React.useEffect(() => {
      import("@arcgis/core/widgets/LayerList").then(({ default: LayerList }) => {

         Util.logMsg("Layer list did update");

         if (!layerListWidget && props.fadeIn) {
            Util.logMsg("Creating LayerList widget");

            //Initialize arrays of unique layers to work around layer List weirdness.
            childLayers = [];
            noChildLayers = [];

            //Legend is created for entire map service, so it looks stupid with map image services.
            let dragEnabled: boolean = true;
            if (Settings.isPhone) {
               dragEnabled = false;
            }

            layerListWidget = new LayerList({
               container: toolDiv,
               view: MainMap.activeView,
               listItemCreatedFunction: listItemCreatedFunction,
               selectionEnabled: dragEnabled,
               visibleElements: { statusIndicators: false },
            });

            layerListWidget.on("trigger-action", layerListTriggerAction);
            setTimeout(function () { createClickEvents(); }, 500); //Hacky

         }
      }).catch((error: Error) => {
         Util.errMsg('An error occurred while loading the Layer List Widget module:', error);
      });
   });

   //This is a hacky onMouseMove way of doing this.  Fix later.
   //function updateHoverParameters() {
   //   Highlight.updateParameters();
   //}

   //Save layer settings.
   function save() {
      let layerType: string;
      let opacity: number;
      let sublayers: Settings.iSublayer[];
      let mtds: Settings.iMapThemesDetail[] = [];

      for (const opLay of layerListWidget.operationalItems) {
         if (opLay.visible) {
            opacity = 1;
            if (opLay.layer.opacity) {
               opacity = opLay.layer.opacity;
            }

            sublayers = getSublayers(opLay.layer as __esri.MapImageLayer);
            addMapThemeDetail(opLay.title, opacity, sublayers, mtds);

            //Group layer.
            layerType = getLayerType(opLay.layer);

            if (layerType === "group") {
               const groupLay = opLay.layer as __esri.GroupLayer;

               for (const lay of groupLay.layers) {
                  if (lay.visible) {
                     opacity = 1;
                     if (lay.opacity) {
                        opacity = lay.opacity;
                     }

                     sublayers = getSublayers(lay as __esri.MapImageLayer);
                     addMapThemeDetail(lay.id, opacity, sublayers, mtds);
                  }
               }
            }
         }
      }

      //Add the basemap.
      const basemap = Util_App.getLayerById(MainMap.map.basemap.id) as __esri.TileLayer;
      addMapThemeDetail(basemap.id, basemap.opacity, [], mtds);

      //Save to local storage.
      const mt: Settings.iMapTheme = { name: themeName, details: mtds, accessLevel: 0 };
      localStorage.SetItem(themeName, mt);
      refresh();
   }

   //Get layer type.
   function getLayerType(opLay: __esri.Layer | __esri.Sublayer): string {
      const layer = opLay as __esri.Layer;
      const sublayer = opLay as __esri.Sublayer;

      if (layer.type) {
         return layer.type;
      }
      return sublayer.layer.type;
   }

   //Get map image service sublayer names and opacities.
   function getSublayers(opLay: __esri.MapImageLayer): Settings.iSublayer[] {
      let sublayers: Settings.iSublayer[] = [];
      let layerType = getLayerType(opLay);

      if (layerType === "map-image") {
         for (const sublay of opLay.allSublayers) {
            if (sublay.visible) {
               sublayers.Add({ name: sublay.title, opacity: sublay.opacity });
            }
         }
      }

      return sublayers;
   }

   //Add map theme detail to array.
   function addMapThemeDetail(id: string, opacity: number, sublayers: Settings.iSublayer[], mtds: Settings.iMapThemesDetail[]) {
      const mtd = { mapServiceID: id, opacity: opacity, sublayers: sublayers };
      mtds.Add(mtd);
   }

   //Clear layer settings.
   function clear() {
      localStorage.RemoveItem(themeName);
      refresh();
   }

   //Enable clear button if a saved theme exists.
   let clearDisabled: boolean = true;
   if (localStorage.Exists(themeName)) {
      clearDisabled = false;
   }

   //Animation is complete.
   function fadeInCompleted() {
      if (layerListWidget) {
         layerListWidget.visible = true;
      }
   }
   function fadeOutCompleted() {
      if (layerListWidget) {
         layerListWidget.visible = false;
      }
   }

   //Close this tool.
   function hide() {
      DrawerMenu.closeTool();
   }

   //Styles.
   const styles: Default.iStyles = {
      appWidgetDiv: { position: 'absolute', top: 0, left: 0, zIndex: 3, minWidth: Settings.leftPanelWidth, overflow: 'auto' },
      mapLayers: { backgroundColor: Settings.paperColor },
   };

   const scrollDivID: string = toolName.replace(" ", "_") + "_Scroll";
   const saveIcon = <Icon color='action'>save</Icon>;
   const clearIcon = <Icon color='action'>clear</Icon>;

   toolDiv = "map-layers-id-" + MainMap.view2D.toString();

   return (
      <Zoom in={props.fadeIn} timeout={500} onEntered={() => fadeInCompleted()} onExited={() => fadeOutCompleted()}>

         <div id="Map_Layers_Widget" style={styles.appWidgetDiv}>
            <Paper>
               <WidgetHeading.Render title={toolName} onClose={hide} />

               <div id={scrollDivID} style={Default.styles.appToolDiv}>
                  <div className="app-flex-row-around">
                     <Button startIcon={saveIcon} variant="outlined" color="info" onClick={save} title="Save map layer settings" aria-label="Save">
                        Save
                     </Button>

                     <Button startIcon={clearIcon} variant="outlined" color="info" onClick={clear} disabled={clearDisabled} title="Clear map layer settings" aria-label="Clear">
                        Clear
                     </Button>
                  </div>

                  <div id={toolDiv} key={toolDiv} style={styles.mapLayers}></div>

                  <Typography variant="body2" style={{ margin: 10 }}>
                     <b><i>Tip:</i></b>&nbsp;&nbsp;To change the display order, drag layers up or down in the list.
                  </Typography>
               </div>

            </Paper>
         </div>
      </Zoom>
   ); //end return.

} //end function.
